import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import {createHashHistory, useQueries} from 'history';
import {syncHistory} from 'redux-simple-router';
import {rootReducer} from './reducers';
import {SiteSettings} from '../base';
import {GlobalState, InitialState} from '../state';
import {loadLanguage, LANG_EN_GB} from '../locale';
import {getUserData} from '../account';
import {updateUnclearedAlarmCount} from '../alarms';
import {enablePageLoad, disablePageLoad} from '../feedback';

/**
 * Instantiates a redux store with the given initial global state
 * and browser history
 *
 * @param state
 * @param history
 * @returns {any}
 */
export function createBaseStore(state: GlobalState,
                                history?: HistoryModule.History) : Redux.Store {
    const reduxRouterMiddleware = syncHistory(history || createHashHistory());
    let middlewares = [reduxRouterMiddleware, thunkMiddleware];
    if (SiteSettings.debug) {
        middlewares.push(createLogger());
    }
    const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);

    return createStoreWithMiddleware(rootReducer, state);
}

function getInitialBlockingData() {
    return (dispatch, getState) => {
        dispatch(enablePageLoad());

        const blockingOps = Promise.all([
            dispatch(loadLanguage(LANG_EN_GB, false)),
            dispatch(getUserData()).then(() => {
                const lang = getState().data.user.language;
                return dispatch(loadLanguage(lang));
            })
        ]);

        return blockingOps.then(() => dispatch(disablePageLoad()));
    };
}

/**
 * Initialises the base store with initial actions and history.
 *
 * @param history
 * @returns {*}
 */
function initStore(history: HistoryModule.History) : any {
    let globalStore = createBaseStore(InitialState, history);

    // page load actions
    // todo: probably better place for these
    globalStore.dispatch(getInitialBlockingData());
    globalStore.dispatch(updateUnclearedAlarmCount());

    return globalStore;
}

export let GlobalHistory = useQueries(createHashHistory)();
export let GlobalStore = initStore(GlobalHistory);
